import React from 'react';
import SearchBar from './SearchBar';
import SearchResultsList from './SearchResultsList';

export default class SearchContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      preventHideDropdown: false,
      showDropdown: true,
      term: '',
      doctors: [],
      patients: [],
      articles: [],
      hospitals: [],
      announcements: [],
      short_videos: [],
      articles_videos: [],
      loading: false,
      hasSearched: false
    }
    this.debounceTimer = null;
    this.hideDropdown = this.hideDropdown.bind(this);
    this.showDropdown = this.showDropdown.bind(this);
    this.setPreventHideDropdown = this.setPreventHideDropdown.bind(this);
    this.resetPreventHideDropdown = this.resetPreventHideDropdown.bind(this);
  }

  search(term) {
    this.setState({ term });

    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    if (!term.trim()) {
      this.setState({
        doctors: [],
        articles: [],
        announcements: [],
        hospitals: [],
        short_videos: [],
        articles_videos: [],
        loading: false,
        hasSearched: false
      });
      return;
    }

    this.setState({ loading: true });

    this.debounceTimer = setTimeout(() => {
      $.ajax({
        url: `/api/autocomplete.json/?term=${term}`,
        method: 'GET',
        success: (data) => {
          this.setState({
            doctors: data.doctors,
            articles: data.articles,
            announcements: data.announcements,
            hospitals: data.hospitals,
            short_videos: data.short_videos,
            articles_videos: data.articles_videos,
            loading: false,
            hasSearched: true
          });
        }
      });
    }, 300);
  }

  setPreventHideDropdown() {
    this.setState({ preventHideDropdown: true });
  }

  resetPreventHideDropdown() {
    this.setState({ preventHideDropdown: false });
  }

  hideDropdown() {
    if (!this.state.preventHideDropdown) {
      this.setState({ showDropdown: false });
    }
  }

  showDropdown() {
    this.setState({ showDropdown: true });
  }

  render() {
    const { loading, showDropdown, term, hasSearched } = this.state;

    return (
      <div>
        <SearchBar
          showDropdown={this.showDropdown}
          hideDropdown={this.hideDropdown}
          term={term}
          onSearchTermChange={(term) => { this.search(term) }}
        />
        {showDropdown && term.trim() && (loading ? this.renderLoading() : this.renderSearchResults())}
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="search-results" id="autocomplete-items">
        <div className="search-results__link">
          <a href={`/en/search?q=${this.state.term}`}>
            <i className="fa fa-search"></i> Search for <strong>{this.state.term}</strong>
          </a>
        </div>
        <div className="search-results__skeleton">
          {[1, 2, 3].map((i) => (
            <div className="search-results__skeleton-item" key={i}>
              <div className="search-results__skeleton-avatar"></div>
              <div className="search-results__skeleton-content">
                <div className="search-results__skeleton-line search-results__skeleton-line--short"></div>
                <div className="search-results__skeleton-line"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderSearchResults() {
    if (!this.state.hasSearched) return null;

    return (
      <SearchResultsList
        setPreventHideDropdown={this.setPreventHideDropdown}
        resetPreventHideDropdown={this.resetPreventHideDropdown}
        term={this.state.term}
        doctors={this.state.doctors}
        articles={this.state.articles}
        hospitals={this.state.hospitals}
        announcements={this.state.announcements}
        short_videos={this.state.short_videos}
        articles_videos={this.state.articles_videos}
      />
    );
  }
}
